/*
 * @Descripttion: 
 * @version: 
 * @Author: A21
 * @Date: 2021-12-21 15:05:36
 * @LastEditors: A21
 * @LastEditTime: 2022-05-17 18:46:43
 * @FilePath: /intell-loan/src/components/v-form/v-form.jsx
 */
import useForm from './useForm';
import FormItem from './FormItem';

export default {
  name: 'vForm',
  data() {
    return {
      formApi: null,
      current: null,
    };
  },
  props: ['rule', 'conponentsList'],
  mounted() {
    const [form] = useForm(this);
    this.formApi = form;
    this.$emit('input', this.formApi);
  },
  destroyed() {
    this.current = null;
  },
  render(h) {
    return (
      <div>
        {this.rule.map((e) => {
          const filItem = this.conponentsList.filter((item) => item.name === e.type);
          if (!filItem.length) {
            return null;
          }
          return h(FormItem, {
            props: {
              params: e,
              form: this.formApi,
              filItem: filItem[0],
            },
          });
        })}
      </div>
    );
  },
};
